import { createQueryClientConfig } from '@data/queries/createQueryClientConfig'
import { isServer, QueryClient } from '@tanstack/react-query'

function makeQueryClient() {
    return new QueryClient(createQueryClientConfig())
}

/**
 * The main QueryClient shared by the entire SPA on the client
 */
let browserQueryClient: QueryClient | undefined = undefined

/**
 * Returns the appropriate query client. Use this any time you want to interact with React Query.
 *
 * @see https://tanstack.com/query/latest/docs/framework/react/guides/advanced-ssr#initial-setup
 */
export function getQueryClient(): QueryClient {
    if (isServer) {
        // Server: always make a new query client
        return makeQueryClient()
    }

    // Browser: make a new query client if we don't already have one
    // This is very important, so we don't re-make a new client if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query client
    if (!browserQueryClient) {
        browserQueryClient = makeQueryClient()
    }

    return browserQueryClient
}
